import { _url } from "../config/utils";
import {
	FLIGHT_BEST_SORT,
	FLIGHT_CHEAPEST_SORT,
	FLIGHT_DEPOSIT_SORT,
	FLIGHT_WEEKLY_SORT,
} from "../constants";

export const FlightSortOptions = [
	{
		value: FLIGHT_BEST_SORT,
		label: "Best",
	},
	{
		value: FLIGHT_CHEAPEST_SORT,
		label: "Cheapest",
	},
	{
		value: FLIGHT_DEPOSIT_SORT,
		label: "Lowest Deposit",
	},
	{
		value: FLIGHT_WEEKLY_SORT,
		label: "Lowest Weekly Repayment",
	},
];

export const FlightClassOption = [
	{
		value: "Y",
		name: "Economy",
		toShow: true,
	},
	{
		value: "S",
		name: "Premium Economy",
		toShow: true,
	},
	{
		value: "C",
		name: "Business",
		toShow: true,
	},
	{
		value: "F",
		name: "First",
		toShow: true,
	},
	{
		value: "P",
		name: "Premium First",
		toShow: false,
	},
	{
		value: "J",
		name: "Premium Business",
		toShow: false,
	},
];

export const US_SITE_POPULAR_DEPARTURE = [
	{
		id: "JFK",
		name: "John F Kennedy Intl",
		city: "New York",
		country: "United States Of America",
		state: "New York",
	},
	{
		id: "ATL",
		name: "Hartsfield-jackson Int",
		city: "Atlanta",
		country: "United States Of America",
		state: "Georgia",
	},
	{
		id: "EWR",
		name: "Newark Liberty Intl",
		city: "New York",
		country: "United States Of America",
		state: "New Jersey",
	},
	{
		id: "LAX",
		name: "Los Angeles Intl",
		city: "Los Angeles",
		country: "United States Of America",
		state: "California",
	},
	{
		id: "PHL",
		name: "Philadelphia Intl",
		city: "Philadelphia",
		country: "United States Of America",
		state: "Pennsylvania",
	},
];

export const CA_SITE_POPULAR_DEPARTURE = [
	{
		id: "YYZ",
		name: "Toronto Pearson International Airport",
		city: "Toronto",
		country: "Canada",
		state: "Ontario",
	},
	{
		id: "YVR",
		name: "Vancouver International Airport ",
		city: "Vancouver",
		country: "Canada",
		state: "British Columbia",
	},
	{
		id: "YUL",
		name: "Montréal–Pierre Elliott Trudeau International Airport ",
		city: "Montreal",
		country: "Canada",
		state: "Quebec",
	},
	{
		id: "YYC",
		name: "Calgary International Airport",
		city: "Calgary",
		country: "Canada",
		state: "Alberta",
	},
	{
		id: "YEG",
		name: "Edmonton International Airport",
		city: "Edmonton",
		country: "Canada",
		state: "Alberta",
	},
];

export const GB_SITE_POPULAR_DEPARTURE = [
	{
		id: "LHR",
		name: "London Heathrow",
		city: "London",
		country: "United Kingdom",
		state: "Greater London",
	},
	{
		id: "MAN",
		name: "Manchester",
		city: "Manchester",
		country: "United Kingdom",
		state: "Greater Manchester",
	},
	{
		id: "BHX",
		name: "Birmingham Int'l",
		city: "Birmingham",
		country: "United Kingdom",
		state: "West Midlands",
	},
	{
		id: "LGW",
		name: "London Gatwick",
		city: "London",
		country: "United Kingdom",
		state: "Greater London",
	},
];

export const US_SITE_POPULAR_ARRIVAL = [
	{
		id: "LAS",
		name: "Mccarran International",
		city: "Las Vegas",
		country: "United States Of America",
		state: "Nevada",
	},
	{
		id: "MCO",
		name: "Orlando Intl",
		city: "Orlando",
		country: "United States Of America",
		state: "Florida",
	},
	{
		id: "MBJ",
		name: "Sangster Intl",
		city: "Montego Bay",
		country: "Jamaica",
		state: "Saint James",
	},
	{
		id: "MIA",
		name: "Miami Intl",
		city: "Miami",
		country: "United States Of America",
		state: "Florida",
	},
	{
		id: "JFK",
		name: "John F Kennedy Intl",
		city: "New York",
		country: "United States Of America",
		state: "New York",
	},
];

export const AU_SITE_POPULAR_DEPARTURE = [
	{
		id: "SYD",
		name: "Kingsford Smith",
		city: "Sydney",
		country: "Australia",
		state: "New South Wales",
	},
	{
		id: "MEL",
		name: "Melbourne Airport",
		city: "Melbourne",
		country: "Australia",
		state: "Victoria",
	},
	{
		id: "BNE",
		name: "Brisbane",
		city: "Brisbane",
		country: "Australia",
		state: "Queensland",
	},
	{
		id: "PER",
		name: "Perth",
		city: "Perth",
		country: "Australia",
		state: "Western Australia",
	},
	{
		id: "ADL",
		name: "International",
		city: "Adelaide",
		country: "Australia",
		state: "South Australia",
	},
];

export const AU_SITE_POPULAR_ARRIVAL = [
	{
		id: "DPS",
		name: "Ngurah Rai",
		city: "Denpasar-bali",
		country: "Indonesia",
		state: "Bali",
	},
	{
		id: "NAN",
		name: "Nadi Intl",
		city: "Nadi",
		country: "Fiji",
		state: "Western",
	},
	{
		id: "AKL",
		name: "Auckland International",
		city: "Auckland",
		country: "New Zealand",
		state: "Auckland",
	},
	{
		id: "APW",
		name: "Faleolo Intl",
		city: "Apia",
		country: "Samoa-independent State Of",
		state: "A`ana",
	},
	{
		id: "MEL",
		name: "Melbourne Airport",
		city: "Melbourne",
		country: "Australia",
		state: "Victoria",
	},
];

export const CA_SITE_POPULAR_ARRIVAL = [
	{
		id: "YEG",
		name: "Edmonton International Airport",
		city: "Edmonton",
		country: "Canada",
		state: "Alberta",
	},
	{
		id: "YYZ",
		name: "Toronto Pearson International Airport",
		city: "Toronto",
		country: "Canada",
		state: "Ontario",
	},
	{
		id: "YUL",
		name: "Montréal–Pierre Elliott Trudeau International Airport ",
		city: "Montreal",
		country: "Canada",
		state: "Quebec",
	},
	{
		id: "YVR",
		name: "Vancouver International Airport ",
		city: "Vancouver",
		country: "Canada",
		state: "British Columbia",
	},
	{
		id: "YYC",
		name: "Calgary International Airport",
		city: "Calgary",
		country: "Canada",
		state: "Alberta",
	},
];

export const GB_SITE_POPULAR_ARRIVAL = [
	{
		id: "JFK",
		name: "John F Kennedy Int'l",
		city: "New York",
		country: "United States Of America",
		state: "New York",
	},
	{
		id: "SFO",
		name: "San Francisco Int'l",
		city: "San Francisco",
		country: "United States Of America",
		state: "New York",
	},
	{
		id: "AMS",
		name: "Amsterdam Schiphol",
		city: "Aalsmeer",
		country: "Netherlands",
		state: "North Holland",
	},
	{
		id: "ATL",
		name: "Hartsfield-Jackson Int'l",
		city: "Atlanta",
		country: "United States Of America",
		state: "Georgia",
	},
	{
		id: "YYZ",
		name: "Toronto Pearson Int'l",
		city: "Toronto",
		country: "Canada",
		state: "Ontario",
	},
	{
		id: "PER",
		name: "Perth",
		city: "Perth",
		country: "Australia",
		state: "Western Australia",
	},
];

export const StopsOptions = [
	{
		value: "0",
		label: "Non Stop",
	},
	{
		value: "1",
		label: "1 stop",
	},
	{
		value: "2",
		label: "2+ stop",
	},
];

export const DepartureTimeOptions = [
	{
		id: "1",
		title: "Morning",
		subTitle: "05:00 - 11:59",
		timeRange: {
			startTime: 5,
			endTime: 12,
		},
		icon: _url("assets/redesign/icons/morning.svg"),
	},
	{
		id: "2",
		title: "Afternoon",
		subTitle: "12:00 - 17:59",
		timeRange: {
			startTime: 12,
			endTime: 18,
		},
		icon: _url("assets/redesign/icons/afternoon.svg"),
	},
	{
		id: "3",
		title: "Evening",
		subTitle: "18:00 - 11:59",
		timeRange: {
			startTime: 18,
			endTime: 24,
		},
		icon: _url("assets/redesign/icons/evening.svg"),
	},
];

export const ArrivalTimeOptions = [
	{
		id: "1",
		title: "Early Morning",
		subTitle: "00:00 - 04:59",
		timeRange: {
			startTime: 0,
			endTime: 5,
		},
		icon: _url("assets/redesign/icons/early_morning.svg"),
	},
	{
		id: "2",
		title: "Morning",
		subTitle: "05:00 - 11:59",
		timeRange: {
			startTime: 5,
			endTime: 12,
		},
		icon: _url("assets/redesign/icons/morning.svg"),
	},
	{
		id: "3",
		title: "Afternoon",
		subTitle: "12:00 - 17:59",
		timeRange: {
			startTime: 12,
			endTime: 18,
		},
		icon: _url("assets/redesign/icons/afternoon.svg"),
	},
	{
		id: "4",
		title: "Evening",
		subTitle: "18:00 - 11:59",
		timeRange: {
			startTime: 18,
			endTime: 24,
		},
		icon: _url("assets/redesign/icons/evening.svg"),
	},
];

export const FlightTripOptions = [
	{
		label: "Round trip",
		value: "return",
	},
	{
		label: "One Way",
		value: "one-way",
	},
	{
		label: "Multicity",
		value: "multi-city",
	},
];
